import React from "react";

import * as style from "./Divider.module.scss";

export const Divider = ({ dark }: { dark: boolean }) => (
  <div className={`${style.divider} ${dark ? style.dark : ""}`}>
    <div />
  </div>
);
